import {h} from 'preact'

function SvgComponent(props) {
  return (
    <svg
      viewBox="0 0 15 24"
      width={15}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke="currentColor"
          strokeWidth={2.667}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.179 15.602h10.005M2.179 2.935v18.134M12.184 9.622v11.447"
        />
        <path
          d="M2.18.402a2.133 2.133 0 100 4.267 2.133 2.133 0 000-4.267zm0 12.533a2.133 2.133 0 100 4.267 2.133 2.133 0 000-4.267zm0-6.387a2.133 2.133 0 100 4.266 2.133 2.133 0 000-4.266zm10.004 1.197a2.133 2.133 0 100 4.267 2.133 2.133 0 000-4.267zm0 11.447a2.133 2.133 0 100 4.266 2.133 2.133 0 000-4.266zm-10.005.515a2.133 2.133 0 100 4.266 2.133 2.133 0 000-4.266z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
